import React, { Component } from 'react';
import PropTypes from 'prop-types';
import marked from 'marked';
import Config from '../config/config';
import './ProductFeature.css';

let fetching = false;

class ProductFeature extends Component {
  constructor(props) {
    super(props);
    this.state = {
      features: [],
    };
  }

  fetchFeatures(){
    const { product } = this.props;
    if(product && product.productfeatures && product.productfeatures.length > 0 && this.state.features.length === 0 && !fetching){
      fetching = true;
      const promiseArr = [];
      product.productfeatures.forEach((feature) => {
        promiseArr.push(
          fetch(`${Config.apiUrl}/productfeatures/${feature.id}`)
          .then(results => results.json())
        );
      });

      Promise.all(promiseArr).then((values) => {
        this.setState({
          features : values
        })
        fetching = false;
      });
    }
  }

  render() {
    this.fetchFeatures();

    // const { product } = this.props;
    let { features } = this.state;

    console.log(features);

    features = features.sort((a, b) => {
      const array_a = a.name.split('-');
      const array_b = b.name.split('-');
      return array_a[array_a.length-1] - array_b[array_b.length-1];
    });

    return (
      <section className="section product-feature">
        {features.map((elem, idx) => (
          <article key={`feature-${idx}`} className="media">
            <figure className="media-left">
              {elem.image && elem.image[0] && 
                <div
                  className="product-feature-img image is-96x96"
                  style={{ backgroundImage: `url(${Config.apiUrl}${elem.image[0].url})` }}
                />
              }
            </figure>
            <div className="media-content">
              <div className="content">
                <div className="product-feature-title" dangerouslySetInnerHTML={{ __html: marked(elem.title) }} />
                <div className="product-feature-description" dangerouslySetInnerHTML={{ __html: marked(elem.description) }} />
              </div>
            </div>
          </article>
        ))}
      </section>
    );
  }
}

ProductFeature.propTypes = {
  product: PropTypes.shape({
    productfeatures: PropTypes.arrayOf(PropTypes.object),
  }),
};

ProductFeature.defaultProps = {
  product: null,
};

export default ProductFeature;



// WEBPACK FOOTER //
// ./src/components/ProductFeature.js